"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var NotificationItem_1 = __importDefault(require("../NotificationItem"));
var BidAccepted_1 = __importDefault(require("../../Icons/Notifications/BidAccepted"));
var schemas_1 = require("@dcl/schemas");
var utils_1 = require("../utils");
var i18N = {
    en: {
        description: function (mana, nftName) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "Your received a bid of ",
            mana,
            " MANA was accepted for ",
            nftName)); },
        title: 'Bid Received'
    },
    es: {
        description: function (mana, nftName) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "Recibiste una oferta de ",
            mana,
            " MANA para ",
            nftName)); },
        title: 'Oferta aceptada'
    },
    zh: {
        description: function (mana, nftName) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "\u60A8\u4E3A ",
            nftName,
            " \u51FA\u4EF7 ",
            mana,
            " MANA \u5DF2\u88AB\u63A5\u53D7")); },
        title: '收到的投标'
    }
};
var BidReceivedNotification = function (_a) {
    var notification = _a.notification, locale = _a.locale;
    return (react_1.default.createElement(NotificationItem_1.default, { image: {
            url: notification.metadata.image,
            rarity: notification.metadata.rarity,
            icon: react_1.default.createElement(BidAccepted_1.default, null)
        }, timestamp: notification.timestamp, isNew: !notification.read },
        react_1.default.createElement("p", { className: "dcl notification-item__content-title" }, i18N[locale].title),
        react_1.default.createElement("p", { className: "dcl notification-item__content-description" }, i18N[locale].description((0, utils_1.formatMana)(notification.metadata.price), react_1.default.createElement("span", null,
            react_1.default.createElement("a", { href: notification.metadata.link, style: {
                    color: "".concat(schemas_1.Rarity.getColor(notification.metadata.rarity)),
                    textDecoration: 'underline'
                } }, notification.metadata.nftName))))));
};
exports.default = BidReceivedNotification;
